// Import mask images
import kn95PpeUs from '../../assets/kn95-ppe-us.webp';
import threePlyPpeUs from '../../assets/3-ply-ppe-us.webp';

export const disposableMasksSpecifications = [
    {
        heading: "Protection",
        description: "95% filtration of particles >0.3 microns in size. KN95 is China code (95%), the N95 is the USA Code (95%), KF94 is Korea code (95%) and FFP2 is the EU code (94%).",
        featuresHeading: "Features",
        features: [
            "The tip-shaped hanging ear design can prevent this dust-proof mask from slipping",
            "Designed for comfortable protection",
            "Lightweight, humidity-resistant and latex-free",
            "The elastic fabric completely fits the face, reusable with no peculiar smell.",
            "The adjustable nose clip is free to adjust providing user-defined sealing and preventing glasses from fogging.",
            "Suitable for different face shapes of men and women",
            "Colors available: White or Black",
            "Packaging: 100 masks per box"
        ],
        image: kn95PpeUs,
        imageAlt: "KN95 Disposable Face Mask"
    },
    {
        heading: "Protection",
        description: "Keeping you away from pollutants and allergens, also great for pet allergens. Three layers of protection help you purify every breath. Great for painting, construction, nail salons, medical, dental uses and people with allergies.",
        featuresHeading: "More Features",
        features: [
            "Made of lightweight and breathable fabric",
            "Three layers of durable protection.",
            "Standard size fits most adults.",
            "Covers nose, mouth, and chin.",
            "Comfortable stretchable ear loops.",
            "Must be sold in increments of 50.",
            "Packaged 50 masks per box - Individually priced.",
            "Color: Blue.",
            "Size: 3.7\" x 6.88\".",
            {
                text: "FDA Registration #3016720241",
                featureDescription: "Designed for single use and is recommended for general public protection."
            },
            "Colors available: Light Blue or Black",
            "Packaging: 50 masks per box"
        ],
        image: threePlyPpeUs,
        imageAlt: "Blue 3 Ply Disposable Face Mask"
    }
]; 